import React from 'react';
import { BadgeContainer, IconContainer } from './styles';

interface BadgeProps {
  text: string;
  color?: string;
  icon?: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({ text, color = 'gray', icon }) => {
  return (
    <BadgeContainer color={color}>
      {icon && <IconContainer>{icon}</IconContainer>}
      {text}
    </BadgeContainer>
  );
};

export { Badge };
